import { DropdownItem, Stack, Typography } from '@optimus-web/core';
import { FormSelectField, lt } from '@mews/framework';
import { TooltippedSpan } from '@mews-commander/ui';
import { useEnterprisesProductContext } from '../../../../context/EnterprisesProductContext';
import { TaxesFieldNames } from '../../../forms/schemas/configureProductFormSchema';
import { useConfigureProductTax } from '../../../../hooks/useConfigureProductTax';
import { TaxRateSelectField } from './TaxRateSelectField';

export const TaxationSinglePropertyForm = () => {
    const {
        state: { enterprises },
    } = useEnterprisesProductContext();

    const { searchTaxRates, taxConfigurationList } = useConfigureProductTax([enterprises[0]?.taxEnvironmentCode]);

    return (
        <Stack vertical spacing="300">
            <Stack vertical spacing="200">
                <Typography textStyle="titleSmallStrong" as="div">
                    {lt('ConfigureProductSubHeadingTax')}
                </Typography>
                <Typography textStyle="bodyMedium" variant="secondary" as="div">
                    {lt('ConfigureProductTaxBody')}
                </Typography>
            </Stack>
            {taxConfigurationList.map(({ taxRates, code, name, localName, countryCode, environmentCode }) => (
                <Stack spacing="200" distribution="stretch" key={code}>
                    <TooltippedSpan tooltip={localName || name}>
                        <FormSelectField
                            readOnly
                            label={lt('ConfigureProductDropdownTaxType')}
                            name={`${TaxesFieldNames.TaxationCode}.${code}`}
                            required
                        >
                            <DropdownItem label={`${localName || name} (${countryCode})`} value={code} />
                        </FormSelectField>
                    </TooltippedSpan>
                    <TaxRateSelectField
                        code={code}
                        environmentCode={environmentCode}
                        searchTaxRates={searchTaxRates}
                        taxRates={taxRates}
                    />
                </Stack>
            ))}
        </Stack>
    );
};
